// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"Services_fadeIn__1CSqE","contact":"Services_contact__3Hbk6"};